
import React from "react";

const Logo = () => {
  return (
    <div className="flex justify-center">
      <img
        src="/lovable-uploads/46abeecd-33a6-4474-bfe9-3f12fba6ee91.png"
        alt="EatsBoost Logo"
        className="w-16 h-16 md:w-20 md:h-20"
      />
    </div>
  );
};

export default Logo;
